import BaseListStyle from "../../styles/BaseListStyle";

const AircraftLoadabilityStyles = (theme) => {
  const baseListStyle = BaseListStyle(theme);
  return {
    ...baseListStyle,
    /* Add custom styles here */
    rooted: {
      display: "flex",
    },
    tableStyle: {
      color: "black",
      fontSize: "14pt",
      fontFamily: "sans-serif",
      textAlign: "center",
      verticalAlign: "middle",
      borderCollapse: "collapse",
      margin: "10px 0",
      // width: "-webkit-fill-available"
      // boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
    },
    headersMain: {
      fontSize:"12.0pt",
      fontWeight:700,
      fontFamily: "Arial, cursive",
      textAlign: "center",
      verticalAlign: "middle",
      whiteSpace: "normal",
    },
    headersSub: {
      fontSize:"9.0pt",
      fontWeight:700,
      fontFamily: "Arial, cursive",
      textAlign: "center",
      verticalAlign: "middle",
      whiteSpace: "normal",
    },
    rowStyle: {
      border: 0,
      borderRight: "1px solid #888888",
      borderBottom: "1px solid #888888"
    },
    noseRowStyle: {
      border: 0,
      borderRight: "1px solid #888888",
      borderLeft: "1px solid #888888",
      borderBottom: "1px solid #888888"
    },
    gridTitles: {
      backgroundImage: "url(/images/LoadabilityHeader.svg)",
      backgroundColor: "#ffffff",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      width: 60,
      height: 40
    },
    heights: {
      verticalAlign: "middle",
      textAlign: "center",
      fontWeight:700,
      backgroundColor: "rgb(48,48,48)",
      color: "#ffffff",
      borderRight: "1px solid #000000",
      borderBottom: "1px solid #000000"
    },
    widths: {
      verticalAlign: "middle",
      textAlign: "center",
      fontWeight:700,
      backgroundColor: "rgb(16,16,16)",
      color: "#ffffff",
      borderRight: "1px solid #000000",
      borderBottom: "1px solid #000000"
    },
    highlighted: {
      backgroundColor: "rgb(233,83,0)",
      color: "#000000",
      fontWeight:700,
    },
    rowHighlight: {
      backgroundColor: "rgba(233,83,0,0.2)",
      color: "#000000",
    },
    columnHighlight: {
      backgroundColor: "rgba(233,83,0,0.2)",
      color: "#000000",
    }
  }
}

export default AircraftLoadabilityStyles;
